import { action } from 'satcheljs';

/**
 * Action to update current settings saving status in the store.
 */
let setIsSaving = action('SET_IS_SAVING_PBP_SETTINGS', (isSaving: boolean) => ({
    isSaving,
}));

export default setIsSaving;
